import { request } from '@/api/client';
import type { CallRecord } from '@/types/callRecord';

export interface CallRecordListParams {
  search?: string;
  status?: string;
  feedback?: string;
  page?: number;
  pageSize?: number;
}

export interface CallRecordListResponse {
  data: CallRecord[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CallRecordStats {
  total: number;
  todayCount: number;
  connected: number;
  interested: number;
  needsCallback: number;
}

export interface CreateCallRecordPayload {
  companyId: string;
  companyName: string;
  contactId: string;
  contactName: string;
  contactPhone: string;
  callDate: string;
  callTime: string;
  status: CallRecord['status'];
  feedback: CallRecord['feedback'];
  notes: string;
  nextFollowUp: string | null;
}

export function fetchCallRecords(params: CallRecordListParams = {}): Promise<CallRecordListResponse> {
  return request<CallRecordListResponse>('/call-records', { params: { ...params } as Record<string, string | number | undefined> });
}

export function fetchCallRecordsByCompany(companyId: string): Promise<CallRecord[]> {
  return request<CallRecord[]>(`/companies/${companyId}/call-records`);
}

export function createCallRecord(payload: CreateCallRecordPayload): Promise<CallRecord> {
  return request<CallRecord>('/call-records', { method: 'POST', body: payload });
}

export function fetchCallRecordStats(): Promise<CallRecordStats> {
  return request<CallRecordStats>('/call-records/stats');
}

export function fetchTodayFollowUps(): Promise<CallRecord[]> {
  return request<CallRecord[]>('/call-records/today-followups');
}

export function fetchCallRecord(id: string): Promise<CallRecord> {
  return request<CallRecord>(`/call-records/${id}`);
}